/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublisherModel } from '../../models/publisher-model';

export interface PublisherIdGet$Plain$Params {
  id: string;
}

export function publisherIdGet$Plain(http: HttpClient, rootUrl: string, params: PublisherIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<PublisherModel>> {
  const rb = new RequestBuilder(rootUrl, publisherIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<PublisherModel>;
    })
  );
}

publisherIdGet$Plain.PATH = '/Publisher/{id}';
